import { CapabilityHistoryItem } from "@pjs/form-response-element";
import { WithBoundaryBridge } from "@pjs/core-ui";
import { react2angular } from "@pebblepad/react2angular";
import { angularAMD } from "@pebblepad/amd";

angularAMD.component("capabilityHistoryItem", react2angular(WithBoundaryBridge(CapabilityHistoryItem), ["onEditJustification", "historyItem", "isEditable", "answeredByCurrentUser"]));
